<template>
  <div
    class="group flex flex-col items-center rounded-small border border-vivid-purple pt-[7px] pb-[15px] max-w-[209px] sm:max-w-[258px] w-full relative"
    :class="customClass"
  >
    <div class="product-label text-vivid-purple text-base" v-if="data.label">
      <div>
        <span
          class="text-end line-clamp-1 font-hebrew font-bold text-xs sm:text-sm md:text-base"
          >{{ data.label }}</span
        >
      </div>
    </div>
    <div
      @click="handleImageClick"
      class="relative w-full"
      :class="{ 'cursor-pointer': !isProduct }"
    >
      <div
        v-if="preview && !isProduct"
        class="absolute h-full invisible items-center opacity-0 w-full flex justify-center group-hover:visible group-hover:opacity-100 transition-all ease-linear duration-300"
      >
        <button
          @click="openModal"
          class="rounded-[22px] hidden items-center gap-2 bg-[#ffffffc7] py-[10px] px-3 max-w-[160px] h-[44px] sm:flex"
        >
          <IconSearch />
          <span class="text-xl font-bold text-vivid-purple font-hebrew"
            >כאפ א בליק</span
          >
        </button>
      </div>
      <div v-if="mainImage">
        <img
          :src="mainImage"
          alt="cart"
          draggable="false"
          class="h-[285px] object-contain"
        />
      </div>
      <div v-else>
        <img
          src="@assets/images/broken.svg"
          alt="cart"
          draggable="false"
          class="h-[285px] object-contain"
        />
      </div>
    </div>
    <div
      v-if="isProduct && images.length"
      dir="rtl"
      class="flex gap-2 mt-2 px-2 w-full justify-center overflow-x-auto"
    >
      <button
        v-for="(image, index) in images"
        :key="index"
        @click="activeImageIndex = index"
        class="shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-small overflow-hidden border-2 transition-all duration-150 ease-linear"
        :class="activeImageIndex === index ? 'border-vivid-purple' : 'border-transparent opacity-60 hover:opacity-100'"
      >
        <img
          :src="image"
          alt="thumbnail"
          draggable="false"
          class="!h-full !w-full !object-cover"
        />
      </button>
    </div>
    <div class="px-2 sm:px-[13px] flex flex-col items-center w-full flex-1">
      <span
        class="text-[15px]/[16px] sm:text-lg/[23px] font-medium sm:font-bold text-vivid-purple font-hebrew mt-[10px] block"
        >{{ data.name }}</span
      >
      <span
        class="text-lg/[19px] sm:text-xl/[27px] text-vivid-purple font-hebrew flex-1"
        >{{ data.description }}</span
      >
      <ButtonBasket :data="data" />
    </div>
  </div>
  <SharedModal v-model="open" v-if="preview && !isProduct" customStyle="w-full">
    <CartPreviewModal :data="data" />
  </SharedModal>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import ButtonBasket from "@components/reusable/ButtonBasket.vue";
import IconSearch from "@components/icons/IconSearch.vue";
import SharedModal from "@components/reusable/SharedModal.vue";
import CartPreviewModal from "@components/reusable/CartPreviewModal.vue";

export default defineComponent({
  components: {
    IconSearch,
    ButtonBasket,
    SharedModal,
    CartPreviewModal,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    customClass: {},
    preview: {
      type: Boolean,
    },
    previewType: {
      type: String,
      default: "issue",
    },
  },
  setup(props) {
    const open = ref(false);
    const activeImageIndex = ref(0);

    const isProduct = computed(() => props.previewType === "product");

    const images = computed<string[]>(() => {
      if (Array.isArray(props.data.images) && props.data.images.length) {
        return props.data.images;
      }
      return props.data.img ? [props.data.img] : [];
    });

    const mainImage = computed(() => {
      if (isProduct.value) {
        return images.value[activeImageIndex.value] ?? null;
      }
      return props.data.img ?? null;
    });

    const openModal = () => {
      open.value = true;
    };
    const closeModal = () => {
      open.value = false;
    };
    const handleImageClick = () => {
      if (!isProduct.value) {
        openModal();
      }
    };

    return {
      open,
      isProduct,
      images,
      activeImageIndex,
      mainImage,
      openModal,
      closeModal,
      handleImageClick,
    };
  },
});
</script>
<style>
.product-label {
  position: absolute;
  z-index: 8;
  right: 0;
  left: .5rem;
  top: 18px;
}
.product-label div{
  display: inline-block;
  position: relative;
  overflow: initial;
  padding-right: 0.5rem;
  padding-left: 1rem;
  filter: drop-shadow(-1px 3px 3px rgba(50, 50, 0, 0.745));
}

.product-label span {
  position: relative;
  z-index: 3;
}

.product-label div:before {
  content:"";
  position: absolute;
  z-index: 2;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;
  background: #edca0d;
  clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%, 10px 50%);
}
</style>
